export default __webpack_public_path__ + "static/spa-ae603196d08c0f8704e7a413d01e419b.jpg";